import PortalAppNavigation from './PortalAppNavigation';

export default PortalAppNavigation;
